import { HttpClient, HttpHeaders, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError,map } from 'rxjs/operators';
import { AuthService } from './auth.service';
import { baseURL } from './baseurl';

@Injectable({
  providedIn: 'root'
})
export class QuestionsService {

  username: string;
  constructor(private authService: AuthService, private http: HttpClient) {
    this.authService.loadUserCredentials(); 
    this.username = this.authService.getUsername();
  }

  getUserquestions():Observable<any>{
   // console.log(baseURL + 'api/questions/');
    return this.http.get<any>(baseURL + 'api/questions/');    
  }

  postUserquestion(text):Observable<any>{
    const authToken = this.authService.getToken();
    const headers = new HttpHeaders({'Authorization': 'Bearer '+ authToken});
    const question = new FormData();
    question.append("text", text);
    return this.http.post<any>(baseURL+'api/questions/',question,{headers})
    .pipe(map(res => {
     // console.log(res);
      return true;
  }))
  }

  getquestionbyID(id):Observable<any>{
   // console.log(baseURL + 'api/questions/'+id);
    return this.http.get<any>(baseURL + 'api/questions/'+id); 
  }

  questionUpvote(id):Observable<any>{
    const authToken = this.authService.getToken();
    const headers = new HttpHeaders({'Authorization': 'Bearer '+ authToken});
    const question = new FormData();
    question.append("question", id);
    return this.http.post<any>(baseURL+'api/questions/upvote-toggle/',question,{headers})
    .pipe(map(res => {
     // console.log(res);
      return true;
  }))
  }

  deletequestionbyID(id):Observable<any>{
    const authToken = this.authService.getToken();
    const headers = new HttpHeaders({'Authorization': 'Bearer '+ authToken});
    //console.log('Question:' + baseURL + 'api/questions/'+id);
    return this.http.delete<any>(baseURL + 'api/questions/'+id,{headers}).pipe(
      map(res=>{
       // console.log(res); 
        return true;
      })
    ); 
  }

  mostpopularquestion():Observable<any>{
    return this.http.get<any>(baseURL + 'api/questions/?ordering=-views');
  }
  
  searchquestion(text):Observable<any>{
    return this.http.get<any>(baseURL + "api/questions/?search=" + text);
  }

  updateQuestion(ques_id,text){
    const authToken = this.authService.getToken();
    const headers = new HttpHeaders({'Authorization': 'Bearer '+ authToken});
    const question = new FormData();
    question.append("text", text);
    return this.http.put<any>(baseURL + 'api/questions/'+ques_id+'/',question,{headers}).pipe(
      map(res=>{
        //console.log(res); 
        return true;
      })
    );
  }
}
